module.exports = "<ng-content></ng-content>\n\n<div *ngIf=\"total_count > current_count\"\n     [ngClass]=\"button_wrapper_class\">\n    <button id=\"load-more-button\"\n            type=\"button\"\n            [ngClass]=\"button_class\"\n            (click)=\"loadMore()\"\n            [disabled]=\"button_disabled\">\n        {{ button_title }}\n    </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/common/components/load-more/load.more.component.html
// module id = 1043
// module chunks = 0